<div class="spinner-container">
  <div class="text">
    <h4 class="spinner-title green-text">{{ controller.getLoadingText() }}</h4>
  </div>
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>
<div class="site-wrapper">
  <div class="site-wrapper-inner" #innerWrapper>
    <app-header></app-header>
    <router-outlet></router-outlet>
  </div>
</div>

@if (controller.getPreviewing() && authService.isAuthenticated() && !(authService.isAuthenticatedHr() && controller.isLibrary())) {
  <div class="backToPreview">
    PREVIEW MODE <div class="align-right"><a (click)="backToStart()">EXIT</a></div>
  </div>
}

@if (controller.getErrorMessage()) {
  <div data-testid="error-banner" [ngClass]="{errorMessage: true, retrying: controller.getRetrying()}" >
    {{controller.getErrorMessage()}}
  </div>
}
